import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/pro-solid-svg-icons/faEllipsisH';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from '../messages';
import style from '../style.module.css';

type ActionsCellProps = {
  row: {
    original: {
      packageTypeId: string;
    };
  };
  onEditPackage: (packageTypeId: string) => void;
  onDeletePackage: (packageTypeId: string) => void;
};

export const ActionsCell = ({ row, onEditPackage, onDeletePackage }: ActionsCellProps) => {
  const { packageTypeId } = row?.original ?? {};

  return (
    <DropdownMenu dropdownMenuClassName={style['action-menu-wrapper']} menuPosition='bottom-right'>
      <DropdownMenuToggler className={style['menu-toggler']} hideChevron theme='link'>
        <div className={style['menu-toggler-contents']}>
          <FontAwesomeIcon icon={faEllipsisH} />
        </div>
      </DropdownMenuToggler>
      <DropdownMenuItem onClick={() => onEditPackage(packageTypeId)}>
        <Text textType={TextType.Label} value={messages.editPackage} />
      </DropdownMenuItem>
      <DropdownMenuItem className={style.danger} onClick={() => onDeletePackage(packageTypeId)}>
        <Text textType={TextType.Label} value={messages.deletePackage} />
      </DropdownMenuItem>
    </DropdownMenu>
  );
};
